var numberFormat = function (number, decimals, dec_point, thousands_sep) {
    /*
3         * 参数说明：
4         * number：要格式化的数字
5         * decimals：保留几位小数
6         * dec_point：小数点符号
7         * thousands_sep：千分位符号
8         * */
    number = (number + '').replace(/[^0-9+-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,

        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.floor(n * k) / k;
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.floor(n)).split('.');
    var re = /(-?\d+)(\d{3})/;
    while (re.test(s[0])) {
        s[0] = s[0].replace(re, "$1" + sep + "$2");
    }

    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
};

var toDecimal = function (x) {
    var f = parseFloat(x);
    if (isNaN(f)) {
        return;
    }
    f = Math.round(x * 100) / 100;
    return f;
};
//强制保留两位


var toDecimal2 = function (x) {
    var f = parseFloat(x);
    if (isNaN(f)) {
        return false;
    }
    f = Math.round(x * 100) / 100;
    var s = f.toString();
    var rs = s.indexOf('.');
    if (rs < 0) {
        rs = s.length;
        s += '.';
    }
    while (s.length <= rs + 2) {
        s += '0';
    }
    return s;
};
//去除空格
//第二个参数输入'g',则去除全部空格
var TrimAll = function (str, is_global) {
    var result;
    result = str.replace(/(^\s+)|(\s+$)/g, "");
    if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
    }
    return result;
};
var getParam = function () {
    var params = location.search;
    var pMap = {};
    if (params.indexOf("?") != -1) {
        params = params.substr(1).split("&");
        for (var i = 0; i < params.length; i++) {
            var param = params[i].split('=');
            pMap[param[0]] = param[1];
        }
    }
    return pMap;
};
var formatDate = function (now, split,hasTime) {
    var time = new Date(now);
    var year = time.getFullYear();
    var month = time.getMonth() + 1;
    var date = time.getDate();
    var hour = time.getHours();
    var minute = time.getMinutes();
    var second = time.getSeconds();
    if (month < 10) {
        month = '0' + parseInt(month)
    }
    if (date < 10) {
        date = '0' + parseInt(date)
    }
    if (hour < 10) {
        hour = '0' + parseInt(hour)
    }
    if (minute < 10) {
        minute = '0' + parseInt(minute)
    }
    if (split === '/') {
        if(hasTime){
            return year + "/" + month + "/" + date + "  " + hour + ":" + minute;
        }else{
            return year + "/" + month + "/" + date;

        }

    }
    if (split === '-') {
        if(hasTime){
            return year + "年" + month + "月" + date+ "日  " + hour + ":" + minute;
        }else{
            return year + "-" + month + "-" + date;
        }

    }
    return year + "年" + month + "月" + date + "日 ";

};

var toThousands = function (num) {
    var result = '', counter = 0;
    num = (num || 0).toString();
    for (var i = num.length - 1; i >= 0; i--) {
        counter++;
        result = num.charAt(i) + result;
        if (!(counter % 3) && i != 0) {
            result = ',' + result;
        }
    }
    return result;
};
var timer = function (inModel, inTime) {
    var countdown = inTime || 30;
    var timeout;
    timeout = setInterval(function () {
        var txt;
        countdown--;
        if (countdown > 0) {
            txt = '获取验证码(' + countdown + 's)';
        } else {
            txt = '获取验证码';
            countdown = inTime || 30;
            inModel.set('disabled', '');
            clearInterval(timeout);
        }
        inModel.set('text', txt);
    }, 1000);
};
//获取滚动条距离顶部的距离
var getScrollTop = function () {
    return (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
};
//设置滚动条距离顶部的距离
var setScrollTop = function () {
    window.scrollTo(0, value);
    return value;
};
// var requestAnimFrame = (function () {
//     return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame ||
//         function (callback) {
//             window.setTimeout(callback, 1000 / 60);
//         };
// })();
var scrollTo = function (to, duration) {
    if
    (duration < 0) {
        setScrollTop(to);
        return
    }
    var diff = to - getScrollTop();
    if (diff === 0) {
        return
    }
    var step = diff / duration * 10;
    requestAnimationFrame(
        function () {
            if (Math.abs(step) > Math.abs(diff)) {
                setScrollTop(getScrollTop() + diff);
                return;
            }
            setScrollTop(getScrollTop() + step);
            if (diff > 0 && getScrollTop() >= to || diff < 0 && getScrollTop() <= to) {
                return;
            }
            scrollTo(to, duration - 16);
        });
};

var getKeyName = function (keycode) {
    var keyCodeMap = {
        8: 'Backspace',
        9: 'Tab',
        13: 'Enter',
        16: 'Shift',
        17: 'Ctrl',
        18: 'Alt',
        19: 'Pause',
        20: 'Caps Lock',
        27: 'Escape',
        32: 'Space',
        33: 'Page Up',
        34: 'Page Down',
        35: 'End',
        36: 'Home',
        37: 'Left',
        38: 'Up',
        39: 'Right',
        40: 'Down',
        42: 'Print Screen',
        45: 'Insert',
        46: 'Delete',
        48: '0',
        49: '1',
        50: '2',
        51: '3',
        52: '4',
        53: '5',
        54: '6',
        55: '7',
        56: '8',
        57: '9',
        65: 'A',
        66: 'B',
        67: 'C',
        68: 'D',
        69: 'E',
        70: 'F',
        71: 'G',
        72: 'H',
        73: 'I',
        74: 'J',
        75: 'K',
        76: 'L',
        77: 'M',
        78: 'N',
        79: 'O',
        80: 'P',
        81: 'Q',
        82: 'R',
        83: 'S',
        84: 'T',
        85: 'U',
        86: 'V',
        87: 'W',
        88: 'X',
        89: 'Y',
        90: 'Z',
        91: 'Windows',
        93: 'Right Click',
        96: 'Numpad 0',
        97: 'Numpad 1',
        98: 'Numpad 2',
        99: 'Numpad 3',
        100: 'Numpad 4',
        101: 'Numpad 5',
        102: 'Numpad 6',
        103: 'Numpad 7',
        104: 'Numpad 8',
        105: 'Numpad 9',
        106: 'Numpad *',
        107: 'Numpad +',
        109: 'Numpad -',
        110: 'Numpad .',
        111: 'Numpad /',
        112: 'F1',
        113: 'F2',
        114: 'F3',
        115: 'F4',
        116: 'F5',
        117: 'F6',
        118: 'F7',
        119: 'F8',
        120: 'F9',
        121: 'F10',
        122: 'F11',
        123: 'F12',
        144: 'Num Lock',
        145: 'Scroll Lock',
        182: 'My Computer',
        183: 'My Calculator',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };
    if (keyCodeMap[keycode]) {
        return keyCodeMap[keycode];
    } else {
        console.log('unKnow Key(Key Code:' + keycode + ')'
        );
        return '';
    }
};
//判断对象是否为空
var isEmptyObject = function(obj) {
    if (!obj || typeof obj !== 'object' || Array.isArray(obj))
    { return false;}
    return !Object.keys(obj).length
};
//生成随机颜色
var randomColor= function() {
    return '#' + ('00000' + (Math.random() * 0x1000000 << 0).toString(16)).slice(-6);
};
//生成指定范围随机数
var randomNum =function(min, max) {
    return Math.floor(min + Math.random() * (max - min));
};
var isEmail = function(str) {
    return/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(str);
};
var isIdCard = function(str) {
    return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/.test(str);
};
//验证电话号码
var isPhoneNum =function(str) {
    return /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/.test(str)
};
//验证Url地址
var isUrl =function(str) {
    return /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i.test(str);
};
//现金额转大写
var digitUppercase = function(n) {
    var fraction = ['角', '分'];
    var digit = ['零','壹', '贰', '叁', '肆', '伍','陆', '柒', '捌', '玖'];
    var unit = [['元', '万', '亿'], ['', '拾', '佰', '仟']];
    var head = n < 0 ? '欠' : '';
    n = Math.abs(n);
    var s = '';
    for (var i = 0; i < fraction.length; i++) {
        s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');
    }
    s = s || '整';
    n = Math.floor(n);
    for (var i = 0; i < unit[0].length && n > 0; i++) {
        var p = '';
        for (var j = 0; j < unit[1].length && n > 0; j++) {
            p = digit[n % 10] + unit[1][j] + p;
            n = Math.floor(n / 10);
        }
        s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
    }
    return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
};
//距离现在时间
var formatPassTime = function(startTime) {
    var currentTime = Date.parse(new Date()),
        time = currentTime - startTime,
        day = parseInt(time / (1000 * 60 * 60 * 24)),
        hour = parseInt(time / (1000 * 60 * 60)),
        min = parseInt(time / (1000 * 60)),
        month = parseInt(day / 30),
        year = parseInt(month / 12);
    if (year) return year + "年前";
    if (month) return month + "个月前";
    if (day) return day + "天前";
    if (hour) return hour + "小时前";
    if (min) return min + "分钟前";
else
    return'刚刚'
};
//距离现在的剩余时间
var formatRemainTime = function(endTime) {
    var startDate = new Date();//开始时间
    var endDate = new Date(endTime);//结束时间
    var t = endDate.getTime() - startDate.getTime();//时间差
    var d = 0, h = 0, m = 0, s = 0;
    if (t >= 0) {
        d = Math.floor(t / 1000 / 3600 / 24);
        h = Math.floor(t / 1000 / 60 / 60 % 24);
        m = Math.floor(t / 1000 / 60 % 60);
        s = Math.floor(t / 1000 % 60);
    }
    return d + "天 " + h + "小时 " + m + "分钟 " + s + "秒";
};
//inTime : 时间戳
//callback: 回调函数
var endTime = function (inTime,callback) {
    var result;
    var timeout = setInterval(function () {
        var day = 0,
            hour = 0,
            minute = 0,
            second = 0;
        if (inTime > 0) {
            day = Math.floor(inTime / (60 * 60 * 24));
            hour = Math.floor(inTime / (60 * 60)) - (day * 24);
            minute = Math.floor(inTime / 60) - (day * 24 * 60) - (hour * 60);
            second = Math.floor(inTime) - (day * 24 * 60 * 60) - (hour * 60 * 60) - (minute * 60);
        }
        if (minute <= 9) minute = '0' + minute;
        if (second <= 9) second = '0' + second;
        inTime--;
        if (inTime >= 0) {
            result =   {
                timeOut:false,
                timeMsg:minute + '分:' + second + '秒'
            }
        } else {
            clearInterval(timeout);
            result=  {
                timeOut:true,
                timeMsg:'00分:00秒  已超时'
            }
        }
        callback(result);
    }, 1000)
};
var getToken = function () {
    return $.cookie('ARTW_token');
};
var clearToken = function () {
    $.cookie('ARTW_token', '');
};
var getReferrer = function() {
    var referrer = '';
    try {
        referrer = window.top.document.referrer;
    } catch(e) {
        if(window.parent) {
            try {
                referrer = window.parent.document.referrer;
            } catch(e2) {
                referrer = '';
            }
        }
    }
    if(referrer === '') {
        referrer = document.referrer;
    }
    return referrer;
};
var remove = function (arr,val) {
  var index =   arr.indexOf(val);
  if(index > -1){
      arr.splice(index,1)
  }
};
var randomWord = function (randomFlag,min,max) {
    var str = "",
        range = min,
        arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    // 随机产生
    if(randomFlag){
        range = Math.round(Math.random() * (max-min)) + min;
    }
    for(var i=0; i<range; i++){
        pos = Math.round(Math.random() * (arr.length-1));
        str += arr[pos];
    }
    return str;
};
module.exports = {
    numberFormat: numberFormat,
    toDecimal: toDecimal,
    toDecimal2: toDecimal2,
    TrimAll: TrimAll,
    getParam: getParam,
    formatDate: formatDate,
    toThousands: toThousands,
    getToken: getToken,
    clearToken: clearToken,
    timer: timer,
    getScrollTop: getScrollTop,
    setScrollTop: setScrollTop,
    getKeyName:getKeyName,
    isEmptyObject:isEmptyObject,
    randomColor:randomColor,
    randomNum:randomNum,
    isEmail:isEmail,
    isIdCard:isIdCard,
    isPhoneNum:isPhoneNum,
    isUrl:isUrl,
    digitUppercase:digitUppercase,
    formatPassTime:formatPassTime,
    formatRemainTime:formatRemainTime,
    endTime:endTime,
    getReferrer:getReferrer,
    remove:remove,
    randomWord:randomWord
};

//获取时间戳
//Date.parse(new Date())
//new Date().getTime()
//(new Date()).valueOf()
//Date now()  ie8up


//typeof(123)  "number"
//typeof('123') "string"
//typeof(a) 如果a为申明 'undefined'
//typeof() 遇到null,arr,obj 都返回'object'


//////////////////
// WEBPACK FOOTER
// ../src/js/util.js
// module id = 2
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32